export const LINEAGE_LAB_PROJECT_ID = "thread-lineage-lab";
export const LINEAGE_LAB_PROJECT_NAME = "Lineage Lab";
export const LINEAGE_LAB_PROJECT_DESCRIPTION =
  "Explore, filter, and stress-test provenance from 20 to 50,000 records.";

export const LINEAGE_LAB_PROJECT_PATH =
  `/v5/${LINEAGE_LAB_PROJECT_ID}?view=lineage&labSize=1000&labViewport=fill`;

export function isLineageLabProjectId(projectId: string | null | undefined): boolean {
  return projectId === LINEAGE_LAB_PROJECT_ID;
}
